import loadable from '@loadable/component';

export const CmsThreeSectionSliderBlockLoadable = loadable(
  () => import('./CmsThreeSectionSliderBlock'),
  { resolveComponent: (module) => module.CmsThreeSectionSliderBlock },
);
